<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">Tags</h3>
      </div>
    </div>
    <div class="page-content">
      <div class="box">
        <div class="field">
          <label class="label">Job Function</label>
          <div class="search-label">
            <div class="select-Jobfunction">
              <span @click="search = true" class="placeholder">
                <label class="error_text">*</label>
                Select Job Function: &nbsp;
              </span>

              <p @click="search = true">
                {{ getSelectedJobFunction ? getSelectedJobFunction.name : "" }}
              </p>

              <input type="text" v-model="jobfunctionId" hidden="hidden" />
            </div>

            <div
              class="seach-box"
              v-if="search"
              v-click-outside="() => chooseJobFunction()"
            >
              <span class="search-box-title">
                <span style="color: white">Please choose the Job Function</span>

                <span @click="search = false">
                  <i
                    style="color: white"
                    class="far fa-times-circle close-btn"
                  ></i>
                </span>
              </span>

              <div class="search">
                <input
                  v-model="searchText"
                  type="text"
                  class="input"
                  placeholder="name"
                />
              </div>

              <div class="search-list">
                <div
                  @click="chooseJobFunction(c._id, index)"
                  class="search-item"
                  v-for="(c, index) in getFilteredJobFunction"
                  :key="index"
                >
                  <p>{{ c.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="field">
          <label class="label">Tag / Keywords</label>
          <div class="control">
            <input
              type="text"
              v-model="searchTags"
              @keyup.enter="searchItems"
              class="input"
              placeholder="Enter keyword and press ENTER"
            />
          </div>
          <div v-if="errorMsg" style="color: red">{{ errorMsg }}</div>
        </div>

        <ul class="selected-list">
          <li v-for="(i, indx) in tags" :key="indx">
            <p>{{ i }}</p>
            <span @click="remove(indx)"><i class="fa-light fa-xmark"></i></span>
          </li>
        </ul>

        <div class="buttons">
          <button class="button light-grey small" @click.prevent="cancelData()">
            <i class="fa-light fa-cancel"></i>
            Cancel
          </button>
          <button
            class="button primary small"
            @click.prevent="saveTags()"
            v-if="!$route.query.id"
          >
            <i class="fa-light fa-plus"></i>
            Save
          </button>
          <button
            class="button primary small"
            @click.prevent="updateTag()"
            v-if="$route.query.id"
          >
            <i class="fa-light fa-plus"></i>
            Save
          </button>
        </div>
      </div>

      <div class="box">
        <div class="tabs">
          <div class="tabs-start">
            <custom :total="totals" />
          </div>

          <div class="tabs-end">
            <div class="search control">
              <input
                type="text"
                v-model="searchJobFunction"
                v-on:keyup="fetchData"
                class="input"
                placeholder="Job Function"
              />
            </div>
          </div>
        </div>

        <table class="table">
          <thead>
            <tr>
              <th class="is-xs">No.</th>

              <th class="is-md">Job Function</th>

              <th class="is-md">Tags / Keywords</th>

              <th class="text-right">Setting</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(i, idx) in allData" :key="idx">
              <td class="is-xs">{{ idx + 1 }}</td>

              <td class="is-md">{{ i.jobFunctionId.name }}</td>

              <td>{{ i.name.join(", ") }}</td>

              <td class="is-xs">
                <div class="icon-group">
                  <span
                    @click="
                      editTags(
                        $router
                          .push({ query: { q: 1, p: 10, id: i._id } })
                          .catch(() => {})
                      )
                    "
                  >
                    <i class="fad fa-cog"></i>
                  </span>

                  <span @click="deleteJobFunction(i._id)" class="alert">
                    <i class="fad fa-trash"></i>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { GET_REUSE } from "@/graphql/manage/query";
import custom from "../../components/Pagination/customPagination";
import vClickOutside from "v-click-outside";
import { apolloClient } from "@/services/apollo-client";
import {
  tagsAPI,
  allTagsAPI,
  deleteTags,
  editTags,
  updateTags,
} from "@/apis/Tags";
export default {
  components: { custom },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => ({
    jobFunction: [],
    jobfunctionId: "",
    searchTags: "",
    tags: [],
    search: false,
    searchText: "",
    errorMsg: "",
    allData: [],
    totals: null,
    searchJobFunction: "",
    tagId: "",
  }),
  computed: {
    getSelectedJobFunction() {
      return this.jobFunction.find((i) => {
        return i._id === this.jobfunctionId;
      });
    },
    getFilteredJobFunction() {
      return this.jobFunction.filter((i) => {
        return i.name.toLowerCase().match(this.searchText.toLowerCase());
      });
    },
  },
  methods: {
    async fetchJobFunction() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          name: this.jobFunction,
          type: "JobFunction",
          page: 1,
          perPage: 5000,
        },
      });
      this.jobFunction = res.data.getReuse.reuseType;
    },
    searchItems() {
      if (!this.searchTags)
        return (this.errorMsg = "Please fill out the item first!");
      this.errorMsg = "";
      this.tags.push(this.searchTags);
      this.searchTags = "";
    },
    chooseJobFunction(jobfunctionId) {
      this.search = false;
      this.jobfunctionId = jobfunctionId;
    },
    remove(index) {
      this.tags.splice(index, 1);
    },
    // Add Tags
    async saveTags() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      if (!this.getSelectedJobFunction || !this.tags.length)
        return (this.errorMsg = "Please fill out the form completely!");
      const form = {
        name: this.tags,
        jobFunctionId: this.getSelectedJobFunction._id,
      };
      await tagsAPI(form)
        .then(async (res) => {
          this.fetchData();
        })
        .catch(async ({ graphQLErrors }) => {
          await this.$dialog.messageError(graphQLErrors[0].message);
        });
    },
    // fetch data
    async fetchData() {
      const form = {
        page: parseInt(this.$route.query.q),
        perPage: parseInt(this.$route.query.p),
        search: this.searchJobFunction,
      };
      const res = await allTagsAPI(form);
      this.allData = res.info;
      this.totals = res.total;
    },
    async deleteJobFunction(id) {
      const form = { _id: id };
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await deleteTags(form)
        .then(async (res) => {
          this.fetchData();
        })
        .catch(async (e) => {
          await this.$dialog.messageError("Can not delete!");
        });
    },
    async editTags() {
      const id = this.$route.query.id;
      if (!id) return;
      const form = { _id: id };
      await editTags(form)
        .then((res) => {
          this.jobFunctionId = res.jobFunctionId._id;
          this.chooseJobFunction(res.jobFunctionId._id);
          this.tagId = res._id;
          this.tags = res.name;
        })
        .catch(async (e) => {
          await this.$dialog.messageError("Data not found!");
        });
    },
    async updateTag() {
      const form = {
        _id: this.tagId,
        name: this.tags,
        jobFunctionId: this.jobFunctionId,
      };
      await updateTags(form)
        .then((res) => {
          this.fetchData();
          this.$router.push({ query: { q: 1, p: 10 } });
        })
        .catch(async (e) => {
          await this.$dialog.messageError("Updating has problematic!");
        });
    },
    cancelData() {
      this.$router.push({ query: { q: 1, p: 10 } }).catch(() => {});
      this.tags = [];
      this.errorMsg = "";
      this.chooseJobFunction();
    },
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val) {
          this.fetchData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.fetchData();
    await this.fetchJobFunction();
  },
};
</script>

<style lang="scss" scoped>
.box {
  margin-bottom: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--border-color);
}
.selected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  border-bottom: 1px solid var(--border-color);
  padding: 0 0 10px;
  li {
    display: flex;
    margin: 0 !important;
    color: #fff;
    border-radius: 5px;
    font-size: var(--sm-font);

    p {
      background-color: var(--light-grey-color);
      margin: 0;
      padding: 8px 15px;
      border-radius: 5px 0 0 5px;
      color: var(--text-color);
    }

    span {
      background-color: var(--grey-color);
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 5px 5px 0;
      cursor: pointer;
      i {
        color: var(--dark-grey-color);
      }

      &:hover {
        background-color: var(--alert-color);
        transition: all ease-in-out 0.3s;
        i {
          color: #fff;
        }
      }
    }
  }
}

.search-label {
  display: flex;
  width: 100%;
  cursor: pointer;
  margin: 0;
  height: 2.5rem;
  transition: all ease-in-out 0.2s;
  font-weight: 500;
  padding-bottom: calc(0.5em - 1px);
  padding-left: calc(0.75em - 1px);
  padding-right: calc(0.75em - 1px);
  padding-top: calc(0.5em - 1px);
  border-radius: var(--radius);
  background-color: var(--light-grey-color);
  &:hover {
    background-color: rgba(#000, 0.15) !important;
  }
  .placeholder {
    color: #000;
    display: flex;
    align-items: center;

    &.error {
      color: var(--alert-color);
    }
  }

  .select-Jobfunction {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 10px;
    p {
      font-weight: 700;
      margin-bottom: 0;
      color: var(--primary-color);
    }
  }

  .seach-box {
    z-index: 1;
    position: relative;
    padding-top: 12px;
    width: 50%;
    border-radius: 5px;
    background-color: var(--primary-color);
    box-shadow: 0 0px 20px 5px rgba(#000, 0.15);
    top: 90px;
    position: absolute;

    .close-btn {
      margin-left: auto;
      cursor: pointer;
    }

    .search-box-title {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;

      &:hover {
        color: inherit;
      }
    }

    .search {
      padding: 10px 20px 20px;

      input {
        background-color: var(--light-grey-color);
        box-shadow: none;
        box-shadow: unset;
        border: none;
        box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
      }
    }

    .search-list {
      border: 1px solid var(--border-color);
      background-color: #fff;
      padding: 20px;
      padding: 0;
      display: block;
      height: 280px;
      overflow-y: scroll;

      .search-item {
        font-size: 14px;
        white-space: pre-line;
        margin: 0;
        padding: 10px 20px;
        transition: all ease-in-out 0.1s;
        cursor: pointer;

        &:not(:last-child) {
          border-bottom: 1px solid var(--border-color);
        }

        &:hover {
          background-color: #dbdbdb;
        }

        p {
          margin: 0;
        }
      }
    }
  }

  // search-box
}
</style>
